import { Box, Button, Card, Flex, Title, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

import { CheckCircle } from "~/icons";

type SuccessRegistrationFormData = {
  success_title: string;
  success_message: string;
  redirect_message: string;
  redirect_hint: string;
  open_app_button: string;
};

export type SuccessRegistrationFormProps = {
  data: SuccessRegistrationFormData;
  onComplete: () => void;
};

export const SuccessRegistrationForm: FC<SuccessRegistrationFormProps> = ({
  data,
  onComplete,
}) => {
  return (
    <Card
      border={{ radius: "16px" }}
      variant="secondary"
      md={{ border: { radius: "8px" } }}
      data-testid="success-registration-form"
    >
      <Flex
        flexDirection="column"
        align="center"
        p={{ px: 16, py: 24 }}
        md={{ p: { pt: 40, pb: 32, px: 40 }, maxWidth: 525 }}
        minWidth={312}
        maxWidth={440}
        minHeight={572}
        d={{ width: 525, minHeight: 640 }}
      >
        <CheckCircle />
        <Title
          color="text-success"
          as="h2"
          size="medium"
          fontWeight="mobile.bold"
          m={{ mt: 32, mb: 8 }}
          data-testid="success-registration-form-title"
        >
          {data.success_title}
        </Title>

        <Typography
          m={{ mb: 32 }}
          size="large"
          data-testid="success-registration-form-message"
        >
          {data.success_message}
        </Typography>

        <Typography m={{ mb: 16 }} size="large">
          {data.redirect_message}
        </Typography>

        <Box
          display="inline-block"
          width={32}
          height={32}
          border={{
            color: {
              top: "border-primary",
              bottom: "border-subtle",
              left: "border-subtle",
              right: "border-subtle",
            },
            radius: "50%",
          }}
          className="animate-spin !border-2"
        />

        <Typography
          color="text-primary-muted"
          size="small"
          m={{ mt: "auto", mb: 16 }}
          md={{
            fontSize: "body.desktop.medium",
            lineHeight: "body.desktop.medium",
          }}
          data-testid="success-registration-form-redirect-hint"
        >
          {data.redirect_hint}
        </Typography>

        <Button
          size="small"
          horizontalAlign="center"
          variant="transparent"
          fontWeight="mobile.bold"
          width="100%"
          p={{ py: 12 }}
          md={{
            p: { py: 18 },
            fontSize: "button.desktop.medium",
            lineHeight: "button.desktop.medium",
          }}
          onPress={onComplete}
          data-testid="success-registration-form-button"
        >
          {data.open_app_button}
        </Button>
      </Flex>
    </Card>
  );
};
